import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mail, Lock, ArrowLeft, Loader2, CheckCircle2 } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import { esqueciSenha, redefinirSenha } from '../lib/api';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_delivery-desk-12/artifacts/76spvmi3_3D4A54DE-AC29-47B8-ABEA-5150F325A161.png';

const Moldura = ({ children }) => (
  <div className="min-h-screen flex flex-col items-center p-6 sm:p-10 bg-white">
    <div className="w-full max-w-md">
      <Link to="/login" className="flex items-center text-sm text-slate-500 hover:text-[#2A5BC7] mb-8">
        <ArrowLeft className="w-4 h-4 mr-1" /> Voltar para o login
      </Link>
      <img src={LOGO_URL} alt="In'Nova Envios" className="h-16 mb-8" />
      {children}
    </div>
  </div>
);

const ResetPasswordPage = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token') || '';
  const [senha, setSenha] = useState('');
  const [senha2, setSenha2] = useState('');
  const [loading, setLoading] = useState(false);
  const [pronto, setPronto] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const salvar = async (e) => {
    e.preventDefault();
    if (senha.length < 6) { toast({ title: 'Senha muito curta', description: 'Use pelo menos 6 caracteres.' }); return; }
    if (senha !== senha2) { toast({ title: 'As senhas não conferem' }); return; }
    setLoading(true);
    try {
      await redefinirSenha(token, senha);
      setPronto(true);
    } catch (err) {
      toast({ title: 'Não foi possível salvar', description: err?.response?.data?.detail || 'Tente novamente.' });
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <Moldura>
        <h1 className="text-2xl font-extrabold text-slate-900">Link incompleto</h1>
        <p className="mt-3 text-slate-600">Abra o link completo que enviamos por e-mail ou peça um novo.</p>
        <Button className="mt-6 inn-btn-primary rounded-full" onClick={() => navigate('/esqueci-senha')}>Pedir novo link</Button>
      </Moldura>
    );
  }
  return (
    <Moldura>
      {pronto ? (
        <div>
          <CheckCircle2 className="w-12 h-12 text-emerald-500 mb-4" />
          <h1 className="text-2xl font-extrabold text-slate-900">Senha atualizada!</h1>
          <p className="mt-3 text-slate-600">Agora é só entrar com seu e-mail e a nova senha.</p>
          <Button className="mt-6 inn-btn-primary rounded-full" onClick={() => navigate('/login')}>Ir para o login</Button>
        </div>
      ) : (
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900">Criar nova senha</h1>
          <p className="mt-2 text-slate-600">Escolha uma senha com pelo menos 6 caracteres.</p>
          <form onSubmit={salvar} className="mt-6 space-y-5">
            <div>
              <Label htmlFor="senha">Nova senha</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input id="senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} className="pl-9 h-11" autoComplete="new-password" />
              </div>
            </div>
            <div>
              <Label htmlFor="senha2">Repita a nova senha</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <Input id="senha2" type="password" value={senha2} onChange={(e) => setSenha2(e.target.value)} className="pl-9 h-11" autoComplete="new-password" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full inn-btn-primary h-12 rounded-full">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Salvando...</> : 'Salvar nova senha'}
            </Button>
          </form>
        </div>
      )}
    </Moldura>
  );
};

export default ResetPasswordPage;
